import { select } from '@ps/web-core-store';
import { isEmpty, isObject } from 'lodash';
import { useSelector } from 'react-redux';

function checkLoggedInContent<T>(loggedInContent: T): boolean {
  if (isObject(loggedInContent)) {
    return Object.values(loggedInContent).some((content) => {
      if (isObject(content)) {
        return checkLoggedInContent(content);
      }

      return !isEmpty(content);
    });
  }

  return !isEmpty(loggedInContent);
}

const useAuthenticatedContent = <T = unknown>(content?: T, loggedInContent?: T): T => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const hasLoggedInContent = checkLoggedInContent(loggedInContent);

  if (isAuthenticated && hasLoggedInContent) {
    return loggedInContent as T;
  }

  return content as T;
};

export default useAuthenticatedContent;
